$(function (){
	let $timelines = $(".timeline");
	const pageIsRMF = !!document.querySelector(".page--RM");

	if (!!$timelines.length) {
		document.documentElement.style.overflowX = "unset";

		$timelines.each(function (){
			const $this = $(this);
			const $nav = $this.find(".timeline__nav");
			const $navList = $nav.find(".timeline__nav-list");
			const $dummyNavItem = $nav.find(".timeline__nav-item");

			let scrollPause = false;

			const $header = $('header.header');

			const events = [...this.querySelectorAll(".timeline__event")];

			let years = events.map(event => {
				const date = event.querySelector(".timeline__event-date");
				return parseInt(date.getAttribute("datetime")) || parseInt(date.textContent);
			});

			let decades = years.map(year => Math.floor(year / 10) * 10);
			let uniqueDecades = decades.filter((decade, index) => decades.indexOf(decade) === index);

			events.forEach((event, i) => {
				event.setAttribute("data-decade", decades[i]);
			});

			const updateListScroll = $activeLink => {
				const activeLinkOffset = $activeLink.offset().left;
				const activeLinkWidth = $activeLink.outerWidth();
				const navListWidth = $navList.outerWidth();
				const navListPadding = parseFloat(window.getComputedStyle($navList[0]).paddingRight);
				const navListScrollLeft = $navList.scrollLeft();

				if ((activeLinkOffset + activeLinkWidth) >= navListWidth - navListPadding) {
					$navList.animate({
						scrollLeft: (activeLinkOffset + activeLinkWidth + navListPadding) - (navListWidth - navListScrollLeft)
					}, 200);
				} else if (activeLinkOffset < 0) {
					$navList.animate({
						scrollLeft: navListScrollLeft + activeLinkOffset - activeLinkWidth
					}, 200);
				}
			};

			const updateNavIndicator = () => {
				let desktop = window.innerWidth > 789;
				const $navIndicator = $nav.find(".timeline__nav-indicator");
				const $activeLink = $nav.find(".timeline__nav-link.is-active");
				const activeLinkWidth = $activeLink.outerWidth();
				const activeLinkOffset = $activeLink.offset().left;
				const navIndicatorOffset = activeLinkOffset - $navList.offset().left + $navList[0].scrollLeft;
				$navIndicator.css("left", navIndicatorOffset);
				$navIndicator.css("width", activeLinkWidth);
				if (desktop) $navIndicator.css("bottom", "12px");
			};

			const setActiveLink = e => {
				$('.timeline__nav-link').removeClass("is-active");
				$(e.target).addClass("is-active");
				if ($navList[0].scrollWidth > $navList.outerWidth()) {
					setTimeout(() => updateListScroll($(e.target)), 300);
				}
				setTimeout(updateNavIndicator, 400);
			};

			const findCurrentDecade = event => {
				const eventDecade = event.attr("data-decade");
				const $link = $(`[href="#decade-${eventDecade}"]`);
				setActiveLink({ target: $link });
			}

			const moveTrackerEls = (e, eventEl) => {
				let $event;
				let desktop = window.innerWidth > 789;
				if (e) {
					const $thisLink = $(e.currentTarget);
					$event = $(`${$thisLink.attr("href")}.timeline__event`);
				} else {
					$event = $(eventEl);
				}
				$(".timeline__event").removeClass("is-active");
				$event.addClass("is-active");
				const $eventDate = $event.find(".timeline__event-date");
				const $tracker = $this.find(".timeline__tracker");
				const $trackerDot = $tracker.find(".timeline__tracker-dot");
				const offset = desktop ? $eventDate.offset().top - $trackerDot.height() * 1.5 : $eventDate.offset().top;
				const $trackerLine = $tracker.find(".timeline__tracker-line");
				const trackerOffset = $tracker.offset().top;
				const trackerDotHeight = $trackerDot.outerHeight();
				const trackerDotOffset = offset - trackerOffset + trackerDotHeight / 2;
				$trackerDot.css("top", trackerDotOffset);
				$trackerLine.css("height", trackerDotOffset);

				findCurrentDecade($event);
			};

			uniqueDecades.forEach(decade => {
				const $item = $dummyNavItem.clone();
				const $link = $item.find(".timeline__nav-link");
				$link.text(decade.toString().trim() + "s");
				$link.attr("href", "#decade-" + decade);
				$navList.append($item);
				$this.find(`[data-decade="${decade}"]`).attr("id", "decade-" + decade);
			});
			
			$(".timeline__nav-item")[0].remove();
			
			if ($navList[0].scrollWidth > $navList.outerWidth()) {
				$navList.css("justify-content", "flex-start");
			}

			$(".timeline__nav-link").on("click", e => {
				e.preventDefault();
				scrollPause = true;
				const $thisLink = $(e.currentTarget);
				const $event = $(`${$thisLink.attr("href")}.timeline__event`);
				const offset = $event.offset().top;
				$("html, body").animate({ scrollTop: offset - 160 }, 500);
				setActiveLink(e);
				moveTrackerEls(e);
				setTimeout(() => scrollPause = false, 500);
			});

			const options = {
				root: null,
				rootMargin: "0px",
				threshold: window.innerWidth > 789 ? 0.85 : 0.36
			}

			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting && !scrollPause) {
						const decade = entry.target.getAttribute("data-decade");
						const $link = $(`[href="#decade-${decade}"]`);
						setActiveLink({ target: $link });
						moveTrackerEls(null, entry.target);
					}
				});
			};

			const observer = new IntersectionObserver(callback, options);

			[...this.querySelectorAll(".timeline__event")].forEach(event => {
				observer.observe(event);
			});
	
			if (!!$header.length) {
				let currentScroll = window.scrollY;
				const throttle = (fn, delay) => {
					let time = Date.now();
					return () => { 
						if((time + delay - Date.now()) <= 0) {
							fn();
							time = Date.now(); 
						} 
					} 
				}
				
				const checkScrollPosition = () => {
					let newScroll = window.scrollY;
					if (newScroll < $header.outerHeight() || newScroll < currentScroll) {
						$nav.css("top", `${$header.outerHeight()}px`);
					} else {
						$nav.css("top", "");
					}
					currentScroll = newScroll;
				}
				
				if (!pageIsRMF) window.addEventListener('scroll', throttle(checkScrollPosition, 100)); 
			}

		});
	}
});